import { h, toast } from './dom';
import { makeRoomCode, normalizeRoomCode } from '../net/room';
import type { KeyMode } from '../media/pipeline';
import type { Role } from '../net/protocol';

export interface JoinRequest {
  code: string;
  role: Role;
  name: string;
  mode: KeyMode;
  /** saved room on the server (photos are stored); absent in quick mode */
  room?: import('../api/client').Room | null;
}

const store = {
  get: (k: string) => { try { return localStorage.getItem(k) ?? ''; } catch { return ''; } },
  set: (k: string, v: string) => { try { localStorage.setItem(k, v); } catch { /* private mode */ } },
};

/** Quick mode (no account): 2 people, room code only, previews only. */
export function renderHome(root: HTMLElement, onJoin: (r: JoinRequest) => void) {
  const params = new URLSearchParams(location.hash.split('?')[1] ?? location.search);
  const invited = normalizeRoomCode(params.get('room') ?? '');

  const name = h('input.field', { placeholder: 'Tên của bạn', maxLength: 20, value: store.get('booth.name') });
  const code = h('input.field.code', { placeholder: 'MÃ PHÒNG', maxLength: 6, value: invited, autocapitalize: 'characters' });
  code.oninput = () => (code.value = normalizeRoomCode(code.value));
  let mode: KeyMode = (store.get('booth.mode') as KeyMode) || 'ai';

  const modeBtn = (m: KeyMode, title: string, sub: string) =>
    h('button.mode', {
      'data-mode': m,
      onclick: () => {
        mode = m;
        store.set('booth.mode', m);
        modes.querySelectorAll('.mode').forEach((b) => b.classList.toggle('on', (b as HTMLElement).dataset.mode === m));
      },
      class: mode === m ? 'on' : '',
    }, h('b', {}, title), h('small', {}, sub));
  const modes = h('div.modes', {},
    modeBtn('ai', '✨ Tách nền AI', 'Không cần phông, dùng MediaPipe'),
    modeBtn('greenscreen', '🟩 Phông xanh', 'Có phông xanh thật – sắc nét nhất'),
  );

  const go = (role: Role, c: string) => {
    const n = name.value.trim() || (role === 'host' ? 'Chủ phòng' : 'Khách');
    store.set('booth.name', n);
    onJoin({ code: c, role, name: n, mode });
  };

  root.replaceChildren(
    h('main.home', {},
      h('div.logo', {}, h('span', {}, '📸'), h('h1', {}, 'Booth', h('em', {}, 'Together')),
        h('p', {}, 'Hai nơi · một khung hình · chụp cùng lúc')),
      h('section.card', {},
        name,
        modes,
        h('button.primary', { onclick: () => go('host', makeRoomCode()) }, '♡ Tạo phòng mới'),
        h('div.or', {}, 'hoặc vào phòng của bạn'),
        h('div.row', {},
          code,
          h('button.secondary', {
            onclick: () => {
              const c = normalizeRoomCode(code.value);
              if (c.length !== 6) return toast('Mã phòng gồm 6 ký tự');
              go('guest', c);
            },
          }, 'Vào phòng'),
        ),
      ),
      h('a.libbtn', { href: '#/login' }, '← Đăng nhập để lưu ảnh & chia sẻ với bạn bè'),
      h('footer.tiny', {}, 'Chế độ nhanh: hình truyền P2P trực tiếp (WebRTC), ảnh không được lưu trên máy chủ'),
    ),
  );
  if (invited) code.focus();
}
